import React, { useContext } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Radio,
  Typography,
} from "@material-ui/core";

// Contexts
import DomainContext from "../../../context/domains/DomainContext";

const DomainAddBox = ({ open_add_box, closeAddBox, add }) => {
  const { projects, new_domain, setNewDomain } = useContext(DomainContext);

  const handleChange = (e, project_id) => {
    setNewDomain({ ...new_domain, project: project_id });
  };

  return (
    <Dialog
      maxWidth="xs"
      fullWidth
      open={open_add_box}
      onClose={(e, reason) => {
        if (!["backdropClick", "escapeKeyDown"].includes(reason)) closeAddBox();
      }}
    >
      <DialogTitle align="center">
        Add Domain <Typography variant="body1"> {new_domain.name} </Typography>{" "}
      </DialogTitle>
      <DialogContent>
        <List>
          {" "}
          {projects &&
            projects.map((project, index) => (
              <ListItem
                key={index}
                button
                onClick={(e) => handleChange(e, project.id)}
              >
                <ListItemIcon>
                  <Radio
                    color="primary"
                    checked={new_domain.project === project.id}
                  />{" "}
                </ListItemIcon>{" "}
                <ListItemText primary={project.name} />{" "}
              </ListItem>
            ))}{" "}
        </List>{" "}
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="center">
          <Grid item xs={6} align="center">
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="default"
              onClick={() => closeAddBox()}
            >
              Cancel{" "}
            </Button>{" "}
          </Grid>
          <Grid item xs={6} align="center">
            <Button
              fullWidth
              size="large"
              variant="contained"
              color="primary"
              // disabled={new_domain.project ? false : true}
              disabled={false}
              onClick={() => add()}
            >
              Add{" "}
            </Button>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </DialogActions>{" "}
    </Dialog>
  );
};

export default DomainAddBox;
